export const orientationOptions = {
	LANDSCAPE: 'landscape',
	PORTRAIT: 'portrait',
};

export const isPortrait = orientation =>
	orientation === orientationOptions.PORTRAIT;
